export function assignServicesToWindow($p: any, services: any): void {
    Object.assign((window as any).services, services);

    Object.keys(services).forEach((key) => {
        $p.service(key, function () {
            return services[key];
        });
    });
}
